module.exports = __webpack_public_path__ + "static/media/tour-reward-blue.9201bee1.svg";